<template>
  <div>
    <el-dialog
      v-model="dialogFormVisible"
      :close-on-click-modal="false"
      :title="title"
      width="500"
      @close="close"
    >
      <el-form ref="form" label-width="120px" :model="form" :rules="rules">
        <!-- 门店 -->
        <!--
        <el-form-item label="门店" prop="branchId">
          <el-select
            v-model="form.branchId"
            placeholder="请选择门店"
            class="fix-width"
          >
            <el-option
              v-for="item in branchList"
              :key="item.branchId"
              :label="item.title"
              :value="item.branchId"
            ></el-option>
          </el-select>
        </el-form-item>
      -->
        <el-form-item label="标题" prop="title">
          <el-input
            v-model.trim="form.title"
            class="fix-width"
            placeholder="请输入标题"
          />
        </el-form-item>
        <el-form-item label="价格" prop="price">
          <el-input
            v-model.trim="form.price"
            class="fix-width"
            placeholder="请输入价格"
          /> 单位：元
        </el-form-item>
        <el-form-item label="时长" prop="duration">
          <el-input
            v-model.trim="form.duration"
            class="fix-width"
            placeholder="请输入时长"
          /> 单位：分钟
        </el-form-item>
        <el-form-item label="备注" prop="text">
          <el-input
            v-model.trim="form.text"
            type="textarea"
            class="fix-width"
            placeholder="请输入备注，选填"
          />
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.order" placeholder="排序" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="save">确 定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { createPayment, updatePayment, } from '@/api/alfmeier'
import { getAllBranchs } from '@/api/branch'
export default {
  name: 'AlfmeierPaymentEdit',
  emits: ['fetch-data'],
  data() {
    return {
      title: '',
      restaurantList: [],
      branchList: [],
      form: {
        paymentId: '',
        branchId: '',
        title: '',
        duration: '10',
        price: '',
        text: '',
        order: 1,
      },
      rules: {
        title: [{ required: true, trigger: 'blur', message: '请输入标题' }],
        price: [{ required: true, trigger: 'blur', message: '请输入价格' }],
        duration: [{ required: true, trigger: 'blur', message: '请输入时长' }],
      },
      dialogFormVisible: false,
    }
  },
  methods: {
    //获取所有门店
    async getAllBranchs() {
      const res = await getAllBranchs({})
      if (!res) return
      this.branchList = res
    },
    async showEdit(row) {
      if (row) {
        this.title = '修改支付'
        this.form.title = row.title
        this.form.duration = row.basic.duration
        this.form.price = row.basic.price
        this.form.text = row.basic.text
        this.form.order = row.basic.order
        this.form.branchId = row.extra.branchId
        this.form.paymentId = row.paymentId
      } else {
        this.title = '新增支付'
      }
      this.dialogFormVisible = true
    },
    close() {
      this.$refs['form'].resetFields()
      this.form = this.$options.data().form
      this.dialogFormVisible = false
    },
    save() {
      this.$refs['form'].validate(async (valid) => {
        if (valid) {
          const paymentId = this.form.paymentId
          const data = Object.assign({}, this.form)
          this.$baseConfirm(
            `你确定要${paymentId ? '修改' : '新增'}支付吗`,
            null,
            async () => {
              paymentId ? await updatePayment(data) : await createPayment(data)
              this.$baseMessage(
                `${paymentId ? '修改' : '新增'}支付成功`,
                'success',
                false,
                'vab-hey-message-success'
              )
              this.$emit('fetch-data')
              this.close()
            }
          )
        } else {
          return false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@mixin size($scale: 1, $type: small) {
  @if $type == large {
    width: 343px * $scale;
  } @else {
    width: 167px * $scale;
  }
  height: 167px * $scale;
}
.avatar-uploader {
  .avatar {
    border-radius: 6px;
    transition: all 0.3s ease-in-out;
    @include size;

    &.large {
      @include size(1, large);
    }
  }
}
.avatar-uploader-icon {
  border: 1px dashed #c0ccda;
  background-color: #fbfdff;
  border-radius: 6px;
  font-size: 28px;
  color: #8c939d;
  width: 148px;
  height: 148px;
  line-height: 148px;
  text-align: center;
}
.tags {
  margin-bottom: 5px;
}
.tags + .tags,
.tags + .button-new-tag {
  margin-left: 10px;
}
.button-new-tag {
  // margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
.disabled .el-upload--picture-card {
  display: none;
}
.fix-width {
  max-width: 500px;
}
.mb-10 {
  margin-bottom: 10px;
}
.ml-10 {
  margin-left: 10px;
}
.mt-10 {
  margin-top: 10px;
}
.tips {
  color: #aaaaaa;
  margin-left: 50px;
}
.error-color {
  color: #f56c6c;
}
.h2 {
  font-weight: bold;
  font-size: 20px;
  margin-top: 20px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
